import React from 'react';
import { Box, Grid, Typography } from '@mui/material';
import { Event } from '../../types/event';
import EventCard from './EventCard';

interface EventSectionProps {
  title: string;
  events: Event[];
  onView: (eventId: string) => void;
}

const EventSection: React.FC<EventSectionProps> = ({ title, events, onView }) => {
  if (events.length === 0) return null;

  return (
    <Box sx={{ mb: 4 }}>
      <Box
        sx={{
          position: 'sticky',
          top: 0,
          zIndex: 2,
          backgroundColor: 'background.default',
          py: 1,
          mb: 1,
        }}
      >
        <Typography variant="h6" fontWeight={600}>
          {title}
        </Typography>
      </Box>
      <Grid container spacing={3}>
        {events.map((event) => (
          <Grid item xs={12} sm={6} lg={4} key={event.id}>
            <EventCard event={event} onView={onView} />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default EventSection;
